
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "./button";
import { cn } from "@/lib/utils";

interface CarouselButtonsProps {
  onNext: () => void;
  onPrevious: () => void;
  canScrollPrevious: boolean;
  canScrollNext: boolean;
  buttonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
}

export function CarouselButtons({
  onNext,
  onPrevious,
  canScrollPrevious,
  canScrollNext,
  buttonProps,
}: CarouselButtonsProps) {
  return (
    <>
      <Button
        variant="outline"
        size="icon"
        className={cn(
          "h-8 w-8 absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-background/80 backdrop-blur-sm",
          !canScrollPrevious && "hidden"
        )}
        onClick={(e) => {
          e.preventDefault();
          onPrevious();
        }}
        {...buttonProps}
        type="button" // Ensure type="button" is applied after spreading buttonProps
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        className={cn(
          "h-8 w-8 absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-background/80 backdrop-blur-sm",
          !canScrollNext && "hidden"
        )}
        onClick={(e) => {
          e.preventDefault();
          onNext();
        }}
        {...buttonProps}
        type="button" // Ensure type="button" is applied after spreading buttonProps
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </>
  );
}
